export default __webpack_public_path__ + "static/media/telegram.239968e0.png";